import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808 } from "@faire/web-api--source/indigofair/settings/ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808";

export const useSettingShowSideBarV2UI = (): boolean =>
  useSetting(ENABLE_ACCOUNT_SETTINGS_LEFT_NAV_V2_UI_240808, true);
